module.exports = __webpack_public_path__ + "static/media/2-1.8a90ce2a.mp3";